import { generatePath } from 'react-router-dom';
import { ASSIGN_PLAYLIST_URL_FRAGMENT, PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../constants/Navigation';
export const ASSIGNMENT_IDS_PARAM = 'assignmentIds';
export const CLOSE_DESTINATION_PARAM = 'closeDestination';
export const getAssignPlaylistUrl = ({
  portalId,
  playlistId,
  assignmentIds,
  closeDestination
}) => {
  const path = generatePath(ASSIGN_PLAYLIST_URL_FRAGMENT, {
    portalId,
    playlistId
  });
  const searchParams = new URLSearchParams();
  if (assignmentIds) {
    assignmentIds.forEach(id => searchParams.append(ASSIGNMENT_IDS_PARAM, id.toString()));
  }
  if (closeDestination) {
    searchParams.set(CLOSE_DESTINATION_PARAM, closeDestination);
  }
  const queryString = searchParams.toString();
  return queryString ? `${path}?${queryString}` : path;
};
export const getPortalAssignmentsUrl = ({
  playlistId,
  documentFragmentLink = false
}) => {
  return `${generatePath(PLAYLIST_URL_FRAGMENT, {
    playlistId
  })}${documentFragmentLink ? '#playlist-assignments' : ''}`;
};
export const getAssignmentsForPortalUrl = ({
  portalId,
  playlistId,
  documentFragmentLink = false
}) => {
  return `${generatePath(PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, {
    portalId,
    playlistId
  })}${documentFragmentLink ? '#playlist-assignments' : ''}`;
};